// Components
import TextField from '@mui/material/TextField';

// Styles
import { styled } from '@mui/material/styles';

const MUITextFieldStyle = styled(TextField)({
  '& label.Mui-focused': {
    color: '#002747',
    backgroundColor: '#ffffff',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#ffffff',
    '& fieldset': {
      borderColor: '#758893',
      borderRadius: 8,
    },
    '&:hover fieldset': {
      borderColor: '#9b722a',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#9b722a',
    },
  },
});

export default MUITextFieldStyle;
